import React from 'react';
import { Header, Grid, Tab, Responsive, SegmentGroup, Segment } from 'semantic-ui-react';
import axios from 'axios';
import StudentUpcomingExams from '../StudentCoursesOverview/StudentUpcomingExams';
import { FormattedMessage } from 'react-intl';
import Announcements from '../Announcements/Announcements';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class StudentHome extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const panes = [
            {
                menuItem: { content: <FormattedMessage id="sidebar.announcements"/> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <Announcements/>
                </Tab.Pane>)
            },
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.upcomingExamsList"/> },
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <StudentUpcomingExams/>
                </Tab.Pane>)
            },
        ];

        return (
            <div>
                <Header as="h1"><FormattedMessage id="sidebar.home"/></Header>
                <Grid centered stackable>
                    <Grid.Row only="mobile tablet">
                        <Grid.Column width={16} stretched>
                            <StudentUpcomingExams/>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row only="computer">
                        <Grid.Column width={16} stretched>
                            <SegmentGroup raised>
                                <Segment>
                                    <Tab menu={{
                                        secondary: true,
                                        pointing: true,
                                        color: 'blue'
                                    }} panes={panes} onTabChange={this.handleTabChange}/>
                                </Segment>
                            </SegmentGroup>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Home/StudentHome.js